import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Solutions from "@/pages/Solutions";

export const Route = createFileRoute("/es/soluciones/")({
  head: () => buildRouteHead("/es/soluciones"),
  component: Solutions,
});

